import * as React from "react";
import { WindowLocation } from "@reach/router";

window.scrollTo = () => {};

export const useScrollTop = (location: WindowLocation | undefined) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
};
